<template>
    <v-card>
    </v-card>
</template>
<script>
import {
    apiGetSubscriptionInfo
} from '@/api/admin.js'
export default {
    components: { 
    },
    name: "Edit",
    data() {
        return {
        }
    },
    methods: {
    },
    created: async function(){
        const org_id = this.$route.params.org_id
        try {
            let result = await apiGetSubscriptionInfo(org_id)
            console.log(result)
        } catch (error) {
            this.$root.vtoast.show({ 
                message: `取得功能模組失敗` 
            })
        }

    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style scoped>
</style>